import {
  Lager_Core_Member,
  Lager_Core_Signatory,
} from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

type CoreSignatoriesType = {
  core_signatories: Array<
    Pick<
      Lager_Core_Signatory,
      'id' | 'admin_sign' | 'can_sign_alone' | 'is_active'
    >
  >;
};
export type MemberType = Pick<
  Lager_Core_Member,
  | 'id'
  | 'name'
  | 'birth_date'
  | 'citizenship'
  | 'company_id'
  | 'name_id'
  | 'orgnr'
  | 'personal_number'
  | 'valu8_id'
> &
  CoreSignatoriesType;
export const MemberFragment = gql`
  fragment SignatoryMember on lager_core_member {
    id
    name
    birth_date
    citizenship
    company_id
    name_id
    orgnr
    personal_number
    valu8_id
    core_signatories(where: { is_active: { _eq: true } }) {
      id
      admin_sign
      can_sign_alone
      is_active
    }
  }
` as TypedDocumentNode<MemberType>;

export type MembersType = { members: Array<MemberType> };
const SignatoryMembersFragment = gql`
  ${MemberFragment}
  fragment SignatoryMembers on lager_core_company {
    members(
      where: {
        is_person: { _eq: true }
        core_signatories: { can_sign_alone: { _eq: true } }
      }
    ) {
      ...SignatoryMember
    }
  }
` as TypedDocumentNode<MembersType>;

export type GetSignatoriesByCompanyIdType = {
  orders_companies_by_pk: { core_company: MembersType };
};
type getSignatoriesByCompanyIdQueryVariables = { company_id: number };

export const getSignatoriesByCompanyId = gql`
  ${SignatoryMembersFragment}
  query GetSignatoriesByCompanyId($company_id: bigint!) {
    orders_companies_by_pk(id: $company_id) {
      id
      core_company {
        id: uid
        ...SignatoryMembers
      }
    }
  }
` as TypedDocumentNode<
  GetSignatoriesByCompanyIdType,
  getSignatoriesByCompanyIdQueryVariables
>;
